import {bool, node, number, shape, string, arrayOf, PropTypes} from 'prop-types';

export const body = {
	id: number.isRequired
};

export const documentShape = shape({
	id: string,
	engagementId: number,
	documentName: string,
	documentChangeTypeId: number
});

export const riskFactorShape = shape({
	id: number.isRequired,
	riskFactorName: string,
	riskFactorRelationId: number,
	formBodyOptionId: number,
	formBodyOptionActionId: number
});

export const header = shape({
	value: string.isRequired,
	label: string,
	orderBy: bool,
	orderByAsc: bool
});

export const dropdownOption = shape({
	name: string,
	render: node.isRequired,
	isVisible: bool
});

export const itProcessShape = shape({
	id: number.isRequired,
	itProcessName: string,
	controls: arrayOf(number)
});

export const itRiskShape = shape({
	id: number.isRequired,
	itRiskName: string,
	hasNoITGC: PropTypes.bool
});

export const itControlsShape = shape({
	allIds: PropTypes.arrayOf(PropTypes.number)
});

export const itBodyShape = shape({
	itControls: itControlsShape
});
